module.exports = __webpack_public_path__ + "static/media/am-warning.ea65e7d5.svg";